exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#canvas{position:fixed}.project-4{background-color:rgba(243,247,253,.9)}.project-3{background-color:rgba(106,223,112,.2)}.portfolio{margin:0 24px}.column{display:flex;flex-direction:column}@media screen and (max-width:950px){.portfolio{flex-direction:column;max-width:700px}.image{width:100%;order:1}.image img{position:static!important}.writing{order:2}.blurb{width:100%!important;background-color:#fafafa}.intro p{margin-bottom:0;margin-top:.7em}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c00927a6","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pages/home.vue
// module id = 287
// module chunks = 0